export const HEALTH_DOT = { red: "#EF4444", yellow: "#F59E0B", green: "#10B981", blue: "#2563EB", gray: "#9CA3AF" };

export const DOT_LEGEND = [
  ["red", "Jeopardy / blocking"],
  ["yellow", "At risk / mitigating"],
  ["green", "On track"],
  ["blue", "Closed"],
  ["gray", "Unassigned / open"],
];

const today = () => new Date().toISOString().slice(0, 10);

export const actionHealth = (a) => {
  if (a.status === "done") return "blue";
  if (a.due_date && a.due_date < today()) return "red";
  if (!(a.owner || "").trim()) return "gray";
  if (a.due_date) {
    const diff = (new Date(a.due_date) - new Date(today())) / 86400000;
    if (diff <= 3) return "yellow";
  }
  return "green";
};

export const riskHealth = (r) => {
  if (r.status === "closed") return "blue";
  if ((r.score || 0) >= 15) return "red";
  if (r.status === "mitigating") return "yellow";
  if (!(r.owner || "").trim()) return "gray";
  return "green";
};

export const decisionHealth = (d) => {
  if (d.status === "decided") return "blue";
  if (d.blocking) return "red";
  if (d.due_date && d.due_date < today()) return "yellow";
  if (!(d.owner || "").trim()) return "gray";
  return "green";
};

export const originOf = (x) =>
  x.meeting_title ? `${x.meeting_title}${x.meeting_date ? ` · ${x.meeting_date}` : ""}` : null;

export const SEVERITY_BANDS = [
  ["Critical", "#EF4444", (s) => (s || 0) >= 15],
  ["High", "#F97316", (s) => (s || 0) >= 10 && (s || 0) < 15],
  ["Moderate", "#F59E0B", (s) => (s || 0) >= 5 && (s || 0) < 10],
  ["Low", "#10B981", (s) => (s || 0) < 5],
];
